import { Gestor } from './gestor';
import { Cedente } from './cedente';
import { PerfilCedenteGestorModel } from './PerfilCedenteGestorModel';

export class CedenteGestor {
    toBlock: boolean;
    statusGestor: string;
    telefone: Telefone;
    constructor(
        public cedenteGestorId: number,
        public gestorId: number,
        public cedenteId: number,
        public dataInicio: Date,
        public dataFim: Date,
        public bloqueado: boolean,
        public gestor: Gestor,
        public cedente: Cedente,
        public perfisGestor: PerfilCedenteGestorModel[]
    ) { }
}

class Telefone {
    public dataBloqueio: Date;
    public ddd: number;
    public id: number;
    public numero: number;
    public pessoa: any;
    public pessoaId: number;
    public tipoTelefone: number;
}
